<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ userIcon }}</md-icon>
            </div>
            <add-button :role="4" @add-click="addUser"></add-button>
          </md-card-header>
          <md-card-content>
            <md-table
              v-model="users"
              class="table-striped"
              table-header-color="primary"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell md-label="Email">{{
                  item.emailAddress
                }}</md-table-cell>
                <md-table-cell md-label="Role">{{
                  formatRoles(item.roles)
                }}</md-table-cell>
                <md-table-cell class="text-right">
                  <md-button
                    class="md-just-icon md-primary"
                    @click="editUser(item.emailAddress)"
                  >
                    <md-icon>create</md-icon> </md-button
                  >&nbsp;
                  <md-button
                    class="md-just-icon md-danger"
                    @click="deleteUser(item.emailAddress)"
                  >
                    <md-icon>delete</md-icon>
                  </md-button>
                </md-table-cell>
              </md-table-row>
              <md-table-empty-state
                md-label="No Users Found"
              ></md-table-empty-state>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
export default {
  async created() {
    await this.getUserListing();
  },
  computed: {
    ...mapGetters({
      users: "user/users",
      userIcon: "user/icon",
      userRole: "user/userRole"
    })
  },
  methods: {
    async getUserListing() {
      await this.$store.dispatch("user/getUserListing");
    },
    deleteUser(emailAddress) {
      Swal.fire({
        text: `Are you sure you want to delete this user?`,
        showCancelButton: true,
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
        confirmButtonText: "Yes, delete them!",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("user/deleteUser", emailAddress)
            .then(() => {
              this.getUserListing();
            })
            .catch(error => {
              this.$notify({
                message: error.response.data,
                icon: "add_alert",
                horizontalAlign: "center",
                verticalAlign: "top",
                type: "danger"
              });
            });
        }
      });
    },
    editUser(id) {
      this.$router.push({
        name: "Edit User",
        params: { emailAddress: id }
      });
    },
    addUser() {
      this.$router.push({ name: "Add User" });
    },
    formatRoles(roles) {
      if (roles.length == 1) {
        return this.userRole(roles[0]).name;
      } else {
        var rolesString = "";
        for (var i = 0; i < roles.length; i++) {
          if (i !== 0) rolesString = rolesString + ", ";
          rolesString = rolesString + this.userRole(roles[i]).name;
        }
        return rolesString;
      }
    }
  }
};
</script>

<style></style>
